{
  "tabs": {
    "lambSummary": "Resumo das Leituras de Cordeiros",
    "beefSummary": "Resumo das Leituras de Bovinos",
    "shiftScores": "Notas do Turno"
  },
  "sitePicker": {
    "label": "Unidade"
  },
  "shiftScores": {
    "windowHours": "Últimas {{count}}h",
    "updatedAt": "Atualizado {{time}}",
    "autoRefresh": "atualiza a cada minuto",
    "unknownOperator": "desconhecido",
    "overview": {
      "graders": "Classificadores no turno",
      "activeLastHour": "{{count}} ativos na última hora",
      "scans": "Escaneamentos",
      "avgScore": "Nota média",
      "aboveWarn": "Acima de {{value}}",
      "lastHourAvg": "Média da última hora"
    },
    "card": {
      "scans": "{{formatted}} escaneamentos",
      "score": "Nota",
      "lastHour": "última hora",
      "vsShift": "vs turno",
      "steady": "estável",
      "firstScan": "Primeiro escaneamento {{time}}",
      "lastScan": "Último escaneamento {{time}}",
      "scansSeries": "Escaneamentos",
      "trend": "Tendência",
      "resetZoom": "Redefinir zoom",
      "bands": {
        "good": "{{value}} ou mais",
        "mid": "{{low}}–{{high}}",
        "low": "abaixo de {{value}}"
      },
      "active": "ativo",
      "aboveWarn": "{{pct}}% ≥ {{value}}"
    },
    "target": "meta {{value}}%"
  },
  "summaryOfScans": {
    "title": {
      "lamb": "Resumo das Leituras de Cordeiros",
      "beef": "Resumo das Leituras de Bovinos"
    },
    "dateRange": "Período",
    "columns": {
      "date": "Data",
      "scans": "Leituras",
      "avgImf": "IMF Médio",
      "avgScanScore": "Pontuação Média da Leitura",
      "avgMsa": "MSA Médio",
      "avgAus": "AUS Médio",
      "avgUsda": "USDA Médio",
      "imf": "IMF",
      "scanScore": "Pontuação da Leitura",
      "msa": "MSA",
      "aus": "AUS",
      "usda": "USDA",
      "scanTime": "Hora da Leitura",
      "chain": "Linha",
      "probe": "Sonda",
      "scanId": "ID da Leitura",
      "actions": "Ações"
    },
    "viewDetails": "Ver detalhes",
    "viewScansFor": "Ver leituras de {{date}}",
    "downloadDay": "Baixar CSV do dia",
    "listOfScans": "Lista de leituras",
    "scanCount_one": "{{count}} leitura",
    "scanCount_other": "{{count}} leituras",
    "close": "Fechar",
    "noScansToDownload": "Nenhuma leitura para baixar neste dia",
    "downloadError": "Falha ao baixar o CSV. Tente novamente."
  }
}
